module.exports = __webpack_public_path__ + "front/img/d16.68cb3924.png";